var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B0CA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,11.5h6c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3h-6 c-0.3,0-0.5,0.1-0.7,0.3C10.1,10,10,10.2,10,10.5s0.1,0.5,0.3,0.7C10.5,11.4,10.7,11.5,11,11.5z M11,14.5h2c0.3,0,0.5-0.1,0.7-0.3 c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3h-2c-0.3,0-0.5,0.1-0.7,0.3C10.1,13,10,13.2,10,13.5 s0.1,0.5,0.3,0.7C10.5,14.4,10.7,14.5,11,14.5z M11,8.5h6c0.3,0,0.5-0.1,0.7-0.3C17.9,8,18,7.8,18,7.5S17.9,7,17.7,6.8 c-0.2-0.2-0.4-0.3-0.7-0.3h-6c-0.3,0-0.5,0.1-0.7,0.3C10.1,7,10,7.2,10,7.5s0.1,0.5,0.3,0.7C10.5,8.4,10.7,8.5,11,8.5z M8,18.5 c-0.6,0-1-0.2-1.4-0.6C6.2,17.5,6,17,6,16.5v-12c0-0.5,0.2-1,0.6-1.4C7,2.7,7.4,2.5,8,2.5h12c0.5,0,1,0.2,1.4,0.6 C21.8,3.5,22,4,22,4.5v12c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6H8z M8,16.5h12v-12H8V16.5z M4,22.5c-0.5,0-1-0.2-1.4-0.6 C2.2,21.5,2,21,2,20.5v-13C2,7.2,2.1,7,2.3,6.8C2.5,6.6,2.7,6.5,3,6.5s0.5,0.1,0.7,0.3C3.9,7,4,7.2,4,7.5v13h13 c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7s-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3H4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventType);
export default __webpack_public_path__ + "static/media/EventType.784cc1929e9157de2ca7611ae9aa6843.svg";
export { ForwardRef as ReactComponent };